import { useMediaQuery } from 'react-responsive'

export function useDevice() {
  const phone = useMediaQuery({ query: '(max-width: 767px)' })
  return {
    phone,
  }
}
